import { render, staticRenderFns } from "./TabContentCategory.vue?vue&type=template&id=119efc91&scoped=true&"
import script from "./TabContentCategory.vue?vue&type=script&lang=js&"
export * from "./TabContentCategory.vue?vue&type=script&lang=js&"
import style0 from "./TabContentCategory.vue?vue&type=style&index=0&id=119efc91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119efc91",
  null
  
)

export default component.exports